import { Injectable, inject } from '@angular/core';

import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { NativePriceCalculatorService } from '@frontend/sports/odds/feature/native-price-calculator';
import { OddsFormatConverterService } from '@frontend/sports/odds/feature/native-price-odds-format-converter';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { ReBetTaxationService } from './re-bet-taxation.service';
import { IReBetPicksPayload } from './re-bet.models';

@Injectable()
export class ReBetCalculatorService {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);
    constructor(
        private oddsFormatConverter: OddsFormatConverterService,
        private taxationService: ReBetTaxationService,
    ) {}

    async getPossibleWinnings(allPicks: IReBetPicksPayload, stake: number): Promise<number> {
        if (!this.getPicksLength(allPicks)) {
            return 0;
        }

        const oddsFormat = this.userOddsFormatSettingsService.oddsFormat;
        const winFixtures = allPicks.winGameFixtures;
        const fixtures = allPicks.fixtures;

        let winnings = NativePrice.fromDecimalsElement(1);

        const winningsSports =
            (fixtures.length &&
                fixtures
                    .map((f) => f.optionGroups[0].options[0].nativePrice)
                    .reduce((total, price) => NativePriceCalculatorService.multiply(total, price, oddsFormat))) ||
            NativePrice.fromDecimalsElement(1);

        const winningsRace =
            (winFixtures.length &&
                winFixtures
                    .map((s) => NativePrice.fromNativePriceElement(s.participants[0].options[0].price))
                    .reduce((total, price) => NativePriceCalculatorService.multiply(total, price, oddsFormat))) ||
            NativePrice.fromDecimalsElement(1);

        winnings = NativePriceCalculatorService.multiply(winningsSports, winningsRace, oddsFormat);
        winnings = NativePriceCalculatorService.multiply(winnings, stake, oddsFormat);

        const wins = this.oddsFormatConverter.getOddsByOddsFormat(winnings);
        const tax = await this.taxationService.getTaxation(wins, allPicks, stake);

        return wins.minus(tax).toNumber();
    }

    getPicksLength(allPicks: IReBetPicksPayload): number {
        return allPicks.fixtures.length + allPicks.winGameFixtures.length + allPicks.xCastFixtures.length;
    }
}
